import { createFileRoute } from '@tanstack/react-router'
import { BansosManager } from '../../../../components/BansosManager'

export const Route = createFileRoute('/desa/$slug/dashboard/bansos')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <BansosManager desaId={desaId} />
  },
})
